import styles from './StudentDiscountSignupMessage.module.scss';
import { GraduationCap } from '@phosphor-icons/react';
import { SVG_SIZE_S } from 'src/constants';

export const StudentDiscountSignupMessage = () => {
  return (
    <div className={styles.root}>
      <h4 className={styles.title}>
        <GraduationCap size={SVG_SIZE_S} />
        <span>Students save 50%</span>
      </h4>
      <div className={styles.description}>
        Sign up with your '.edu' university email <br />
        and get 50% off any individual plan. <br />
        Discount applied at checkout.
      </div>
    </div>
  );
};
